import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-18/task-01";

const task: Slide = {
  title: "Indicate which measures will yield good airborne sound insulation of a single-leaf wall.",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
